// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4":"961a3039","176":"39e625c4","378":"7d585589","608":"39e625c4","692":"39e625c4"}[chunkId] + ".chunk.css";
};